(function($, site, google) {
  "use strict";
  site.locator = site.locator || {};

  site.locator.geocoder = _.extend(site.locator.geocoder || {}, {
    find: function(args) {
      if (!args || !args.params) {
        return false;
      }

      this.get().geocode(args.params, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (args.resultFilter) {
            if (typeof args.resultFilter === 'object') {
              args.successHandler(site.locator.geocoder.resultFilter(_.extend({ results: results }, args.resultFilter)), results);
            } else if (typeof args.resultFilter === 'function') {
              args.successHandler(args.resultFilter({ results: results }), results);
            }
          } else {
            args.successHandler(results, results);
          }
        } else {
          if (args.errorHandler) {
            args.errorHandler(results, status);
          } else if (args.errorHandlers) {
            _.each(_.omit(google.maps.GeocoderStatus, 'OK'), function (val, key, list) {
              if (status === val) {
                args.errorHandlers[key](results, status);
              }
            });
          }
        }
      });
    },
    get: function() {
      if (!this.geocoder) {
        this.geocoder = new google.maps.Geocoder();
      }
      return this.geocoder;
    },
    resultFilter: function(args) {
      if (!args || !args.results) {
        return false;
      }

      var returnedResults = _.clone(args.results),
        blacklist = args.blacklist instanceof Array ? args.blacklist : _.union([
            "country",
            "route"
          ], args.blacklist && args.blacklist.add ? args.blacklist.add : []),
        partialBlacklist = args.partialBlacklist instanceof Array ? args.partialBlacklist : _.union([
            "point_of_interest",
            "premise",
            "subpremise"
          ], args.partialBlacklist && args.partialBlacklist.add ? args.partialBlacklist.add : []),
        whitelist = args.whitelist instanceof Array ? args.whitelist : _.union([
            "postal_code"
          ], args.whitelist && args.whitelist.add ? args.whitelist.add : []),
        partialWhitelist = args.partialWhitelist instanceof Array ? args.partialWhitelist : _.union([
          ], args.partialWhitelist && args.partialWhitelist.add ? args.partialWhitelist.add : []),
        foundMatch = false;

      _.each(args.results, function(result, i) {
        if (args.blacklist) {
          if (_.intersection(blacklist, result.types).length > 0) {
            returnedResults.splice(_.indexOf(returnedResults, result), 1);
            return;
          }
        } else if (args.whitelist) {
          if (_.intersection(whitelist, result.types).length > 0) {
            foundMatch = true;
          }
        }

        if (result.partial_match) {
          if (args.partialBlacklist) {
            if (_.intersection(partialBlacklist, result.types).length > 0) {
              returnedResults.splice(_.indexOf(returnedResults, result), 1);
              return;
            }
          } else if (args.partialWhitelist) {
            if (_.intersection(partialWhitelist, result.types).length > 0) {
              foundMatch = true;
            }
          }
        }

        if (args.whitelist || args.partialWhitelist) {
          if (!foundMatch) { // if we didn't find a whitelist/partialWhitelist match...
            returnedResults.splice(_.indexOf(returnedResults, result), 1); // remove the element from the array, since no whitelist match was found
          } else { // if we did...
            foundMatch = false; // reset the foundMatch switch for the next iteration
          }
        }
      });

      return returnedResults;
    }
  });

  // factory function, for map pins for store locator
  site.locator.MapLocationIcon = (function() {
    var MapLocationIcon = function(args) {
        this.id = args.id;
        this.label = args.label; // the content to be fetured inside the custom map pin
        this.htmlContent = args.htmlContent; // if html content is desired instead of a simple text label
        this.icon_class = args.icon_class;
        this.pos = args.latlng;
        this.dataAttrs = args.dataAttrs;
        this.set("position", args.latlng);
        this.setMap(args.map);
        this.clickHandler = args.clickHandler;
        this.added = false;
        this.onAddHandler = args.onAddHandler;
        this.rendered = false;
        this.onRenderedHandler = args.onRenderedHandler;
      },
      initialize = function() {
        MapLocationIcon.prototype = new google.maps.OverlayView();
        MapLocationIcon.prototype.onRemove = function() {
          this.div.parentNode.removeChild(this.div);
          this.div = null;
        };

        //prepare the overlay with DOM
        MapLocationIcon.prototype.onAdd = function() {
          var div = document.createElement('div'),
            $div = $(div);
          $div.addClass('map-marker').addClass(this.icon_class);
          $div.css({
            'position': 'absolute'
          });
          if (this.label) {
            $div.text(this.label);
          } else if (this.htmlContent) {
            $div.html(this.htmlContent);
          }
          $div.trigger('click', this.clickHandler);
          if (this.dataAttrs && this.dataAttrs.length > 0) {
            for (var i = 0; i < this.dataAttrs.length; i += 1) {
              $div.attr(this.dataAttrs[i].key.indexOf("data-") === 0 ? this.dataAttrs[i].key : "data-" + this.dataAttrs[i].key, this.dataAttrs[i].value);
            }
          }

          this.div = div;

          var panes = this.getPanes();
          panes.overlayImage.appendChild(div);
          this.added = true;
          if (this.onAddHandler) {
            this.onAddHandler();
          }
        };

        //set position
        MapLocationIcon.prototype.draw = function() {
          var overlayProjection = this.getProjection();
          var position = overlayProjection.fromLatLngToDivPixel(this.pos);
          var panes = this.getPanes();
          var $div = $(this.div);
          $div.css({
            'left': (position.x - ($div.width() / 2)) + 'px',
            'top':  (position.y - $div.height()) + 'px'
          });
          this.rendered = true;
          if (this.onRenderedHandler) {
            this.onRenderedHandler();
          }
        };

        MapLocationIcon.prototype.getPosition = function() {
          return this.pos;
        };
      },
      initialized = false;

      return function(args) {
        if (!initialized) {
          if (google.maps) {
            initialize();
            initialized = true;
          } else {
            throw new Error("Can't instantiate MapLocationIcon: google.maps is not yet available.");
          }
        }

        return new MapLocationIcon(args);
      };
  }());

})(jQuery, window.site = window.site || {}, window.google = window.google || {});
